import * as React from "react";
const SvgArrowDropdownDoubts = (props) => /* @__PURE__ */ React.createElement("svg", { width: 8, height: 4, viewBox: "0 0 8 4", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M3.75 3.75L0 0H7.5L3.75 3.75Z", fill: "#393E44" }));
export default SvgArrowDropdownDoubts;
